(function () {
  var ceIsEnglish = /^\/en(?:\/|$)/.test(window.location.pathname) || ((document.documentElement.lang || '').toLowerCase().indexOf('en') === 0);

  function normalize(value) {
    return (value || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  function focusSearchInput(input) {
    if (!input) return;
    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      input.focus();
    }
    try {
      var end = input.value.length;
      input.setSelectionRange(end, end);
    } catch (error) {}
  }

  function isMobileSearchViewport() {
    return !window.matchMedia || window.matchMedia('(max-width: 767px)').matches;
  }

  function getSearchFocusRoot(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-ce-search-bar], .ce-home__search-panel, .caboeletro-search-form, .t4s-mini-search__frm, .t4s-search-header__form, form[role="search"]');
  }

  function getSearchFocusInput(root) {
    if (!root || !root.querySelector) return null;
    return root.querySelector('[data-ce-search-input], [data-input-search], input[name="q"]:not([type="hidden"]), input[type="search"]');
  }

  function triggerSearchFocus(event) {
    var root = getSearchFocusRoot(event.target);
    if (!root || !isMobileSearchViewport()) return;
    var input = getSearchFocusInput(root);
    if (!input || event.target === input) return;
    var isEmptyButton = event.target.closest('button') && !input.value.trim();
    if (!isEmptyButton && event.target.closest('button, input, select, textarea, a')) return;
    if (event.cancelable) event.preventDefault();
    focusSearchInput(input);
  }

  function focusHiddenSearchDrawer() {
    if (!isMobileSearchViewport()) return false;
    var drawer = document.querySelector('#t4s-search-hidden');
    var input = drawer && getSearchFocusInput(drawer);
    if (!input) return false;
    focusSearchInput(input);
    return true;
  }

  function scheduleHiddenSearchFocus() {
    if (focusHiddenSearchDrawer()) return;
    [80, 220, 480, 780].forEach(function (delay) {
      window.setTimeout(focusHiddenSearchDrawer, delay);
    });
  }

  function displaySearchQuery(value) {
    return (value || '').toString().replace(/\*+$/, '');
  }

  function shouldWildcardSearchToken(token) {
    var clean = (token || '').replace(/^[^\w]+|[^\w]+$/g, '');
    if (clean.length < 3 || clean.length > 32) return false;
    if (!/^[A-Za-z0-9][A-Za-z0-9._/-]*$/.test(clean)) return false;
    if (!/[A-Za-z]/.test(clean)) return false;
    if (/\d/.test(clean)) return true;
    return clean.toLowerCase() === 'eja';
  }

  function codeWildcardSearchQuery(value) {
    var query = (value || '').toString().trim();
    if (!query || /\*$/.test(query) || /[:"]/g.test(query)) return query;
    var parts = query.split(/\s+/);
    var last = parts[parts.length - 1];
    if (!shouldWildcardSearchToken(last)) return query;
    parts[parts.length - 1] = last + '*';
    return parts.join(' ');
  }

  var ceSearchWasWildcardServerRendered = false;

  function cleanVisibleSearchUrl() {
    if (window.location.pathname.indexOf('/search') === -1 || !window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    var query = params.get('q') || '';
    var visibleQuery = displaySearchQuery(query);
    if (!query || visibleQuery === query || /[:"]/g.test(query)) return;
    params.set('q', visibleQuery);
    ceSearchWasWildcardServerRendered = true;
    window.history.replaceState(window.history.state, document.title, window.location.pathname + '?' + params.toString() + window.location.hash);
  }

  function cleanVisibleSearchInputs(root) {
    (root || document).querySelectorAll('form[role="search"] input[name="q"]').forEach(function (input) {
      input.value = displaySearchQuery(input.value);
    });
  }

  function cleanVisibleSearchLinks(root) {
    (root || document).querySelectorAll('a[href*="/search"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      try {
        var url = new URL(href, window.location.origin);
        var query = url.searchParams.get('q') || '';
        var visibleQuery = displaySearchQuery(query);
        if (!query || visibleQuery === query || /[:"]/g.test(query)) return;
        url.searchParams.set('q', visibleQuery);
        link.setAttribute('href', url.pathname + '?' + url.searchParams.toString() + url.hash);
      } catch (error) {}
    });
  }

  function buildWildcardSearchUrl(href) {
    try {
      var url = new URL(href, window.location.origin);
      if (url.pathname.indexOf('/search') === -1) return null;
      var query = url.searchParams.get('q') || '';
      var visibleQuery = displaySearchQuery(query);
      var upgraded = codeWildcardSearchQuery(visibleQuery);
      if (!visibleQuery || !upgraded || upgraded === visibleQuery) return null;
      url.searchParams.set('q', upgraded);
      if (!url.searchParams.has('type')) url.searchParams.set('type', 'product');
      if (!url.searchParams.has('options[prefix]')) url.searchParams.set('options[prefix]', 'last');
      return url;
    } catch (error) {
      return null;
    }
  }

  function buildVisibleSearchPath(href) {
    try {
      var url = new URL(href, window.location.origin);
      var query = url.searchParams.get('q') || '';
      var visibleQuery = displaySearchQuery(query);
      if (query && visibleQuery && !/[:"]/g.test(query)) url.searchParams.set('q', visibleQuery);
      return url.pathname + '?' + url.searchParams.toString() + url.hash;
    } catch (error) {
      return href;
    }
  }

  function replaceSearchPage(html, visiblePath, useReplaceState) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var current = document.querySelector('.t4s-search-page');
    var next = doc.querySelector('.t4s-search-page');
    if (!current || !next) return false;
    current.replaceWith(document.importNode(next, true));
    if (visiblePath && window.history && window.history.pushState) {
      if (useReplaceState) window.history.replaceState(window.history.state, document.title, visiblePath);
      else window.history.pushState({}, document.title, visiblePath);
    }
    cleanVisibleSearchInputs();
    cleanVisibleSearchLinks();
    try { window.dispatchEvent(new Event('resize')); } catch (error) {}
    return true;
  }

  function fetchWildcardSearchPage(fetchUrl, visiblePath, useReplaceState) {
    var searchPage = document.querySelector('.t4s-search-page');
    if (searchPage) searchPage.classList.add('is-loading');
    fetch(fetchUrl.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.text();
      })
      .then(function (html) {
        if (!replaceSearchPage(html, visiblePath, useReplaceState)) window.location.href = visiblePath || fetchUrl.toString();
      })
      .catch(function () {
        window.location.href = visiblePath || fetchUrl.toString();
      });
  }

  function hydrateWildcardSearchResults() {
    if (window.location.pathname.indexOf('/search') === -1 || !window.fetch || !window.DOMParser) return;
    if (ceSearchWasWildcardServerRendered) return;
    var params = new URLSearchParams(window.location.search);
    var query = params.get('q') || '';
    var visibleQuery = displaySearchQuery(query);
    var upgraded = codeWildcardSearchQuery(visibleQuery);
    if (!visibleQuery || !upgraded || upgraded === query || upgraded === visibleQuery) return;

    params.set('q', upgraded);
    if (!params.has('type')) params.set('type', 'product');
    if (!params.has('options[prefix]')) params.set('options[prefix]', 'last');

    fetchWildcardSearchPage(window.location.pathname + '?' + params.toString() + window.location.hash, null, true);
  }

  function prepareWildcardSearchSubmit(form, input) {
    var visibleQuery = displaySearchQuery(input.value);
    var upgraded = codeWildcardSearchQuery(visibleQuery);
    input.value = visibleQuery;
    if (!visibleQuery || !upgraded || upgraded === visibleQuery) return;

    var hidden = form.querySelector('[data-ce-wildcard-search-query]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'q';
      hidden.setAttribute('data-ce-wildcard-search-query', '');
      form.appendChild(hidden);
    }
    hidden.value = upgraded;
    input.setAttribute('data-ce-visible-search-name', input.getAttribute('name') || '');
    input.removeAttribute('name');

    window.setTimeout(function () {
      if (!document.documentElement.contains(form)) return;
      hidden.remove();
      if (!input.getAttribute('name')) input.setAttribute('name', input.getAttribute('data-ce-visible-search-name') || 'q');
      input.removeAttribute('data-ce-visible-search-name');
    }, 1500);
  }

  cleanVisibleSearchUrl();
  cleanVisibleSearchInputs();
  cleanVisibleSearchLinks();
  hydrateWildcardSearchResults();

  /* Mobile keyboard fix: previously pointerdown/touchend/click called
     preventDefault + programmatic input.focus(). On iOS/Android the on-screen
     keyboard only opens when focus comes directly from the user's tap on the
     input itself — a programmatic focus leaves the field focused WITHOUT the
     keyboard, forcing a second tap. The CSS makes the input the full-width tap
     target (icon is pointer-events:none, input on top), so native taps open the
     keyboard in a single tap. */

  document.addEventListener('click', function (event) {
    if (!isMobileSearchViewport() || !event.target.closest) return;
    var trigger = event.target.closest('[data-drawer-options*="t4s-search-hidden"]');
    if (!trigger) return;
    scheduleHiddenSearchFocus();
  }, true);

  /* Ao abrir o carrinho a partir do menu mobile, feche primeiro a navegação
     principal para que os dois drawers não fiquem sobrepostos. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('[data-ce-cart-drawer]')) return;
    var navToggle = document.getElementById('ce-nav-toggle');
    if (navToggle) navToggle.checked = false;
  }, true);

  document.addEventListener('submit', function (event) {
    var bar = getSearchFocusRoot(event.target);
    if (!bar) return;
    var input = getSearchFocusInput(bar);
    if (!input || input.value.trim()) return;
    if (!isMobileSearchViewport()) return;
    event.preventDefault();
    focusSearchInput(input);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[role="search"]');
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    prepareWildcardSearchSubmit(form, input);
  }, true);

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link || !link.closest('.t4s-search-page') || event.defaultPrevented) return;
    if (link.target && link.target !== '_self') return;
    var fetchUrl = buildWildcardSearchUrl(link.getAttribute('href'));
    if (!fetchUrl) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    fetchWildcardSearchPage(fetchUrl, buildVisibleSearchPath(link.getAttribute('href')), false);
  }, true);

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-ce-directory-search]');
    if (!input) return;

    var directory = input.closest('[data-ce-directory]');
    if (!directory) return;

    var query = normalize(input.value);
    var visibleCount = 0;
    directory.querySelectorAll('[data-ce-item]').forEach(function (item) {
      var label = normalize(item.getAttribute('data-ce-label') || item.textContent);
      var isVisible = !query || label.indexOf(query) !== -1;
      item.hidden = !isVisible;
      item.style.display = isVisible ? '' : 'none';
      if (isVisible) visibleCount += 1;
    });
    var empty = directory.querySelector('[data-ce-directory-empty-filter]');
    if (empty) {
      var showEmpty = !!query && visibleCount === 0;
      empty.hidden = !showEmpty;
      empty.style.display = showEmpty ? '' : 'none';
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('.ce-sort__select');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });

  // Clamp the product quantity input to the available stock.
  function clampQty(input) {
    var max = parseInt(input.getAttribute('data-ce-qty-max'), 10);
    if (!max || isNaN(max)) return;
    var val = parseInt(input.value, 10);
    var hint = input.parentNode.querySelector('[data-ce-qty-hint]');
    if (val > max) {
      input.value = max;
      if (hint) {
        hint.classList.add('is-warning');
        hint.textContent = ceIsEnglish ? ('Maximum available: ' + max + ' in stock') : ('Máximo disponível: ' + max + ' em estoque');
      }
    } else if (hint) {
      hint.classList.remove('is-warning');
      hint.textContent = ceIsEnglish ? (max + ' available in stock') : (max + ' disponíveis em estoque');
    }
  }
  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-ce-qty-max]');
    if (input) clampQty(input);
  });
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-ce-qty-max]');
    if (input) clampQty(input);
  });

  var counters = document.querySelectorAll('.ce-stat__val[data-count]');
  if (counters.length) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fmt = function (n) { return n.toLocaleString(ceIsEnglish ? 'en-US' : 'pt-BR'); };
    var run = function (el) {
      var target = parseInt(el.getAttribute('data-count'), 10) || 0;
      if (reduce) { el.textContent = fmt(target); return; }
      var dur = 1400, start = null;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(Math.round(target * eased));
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = fmt(target);
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (c) { io.observe(c); });
    } else {
      counters.forEach(run);
    }
  }

  var gallery = document.querySelector('[data-ce-gallery]');
  if (gallery) {
    var galMain = gallery.querySelector('[data-ce-gallery-main]');
    var galImg = galMain ? galMain.querySelector('img') : null;
    var galThumbs = [].slice.call(gallery.querySelectorAll('[data-ce-thumb]'));

    galThumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (galImg) {
          galImg.src = t.getAttribute('data-full') || t.src;
          galImg.setAttribute('data-zoom', t.getAttribute('data-zoom') || galImg.src);
          if (t.alt) galImg.alt = t.alt;
        }
        galThumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    var lb;
    var openLb = function (src) {
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'ce-lightbox';
        lb.innerHTML = '<button type="button" class="ce-lightbox__close" aria-label="' + (ceIsEnglish ? 'Close' : 'Fechar') + '">×</button><img alt="">';
        document.body.appendChild(lb);
        lb.addEventListener('click', function (e) {
          if (e.target === lb || e.target.classList.contains('ce-lightbox__close')) closeLb();
        });
      }
      lb.querySelector('img').src = src;
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    };
    var closeLb = function () {
      if (lb) { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    };
    if (galMain && galImg) {
      galMain.addEventListener('click', function () { openLb(galImg.getAttribute('data-zoom') || galImg.src); });
      galMain.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(galImg.getAttribute('data-zoom') || galImg.src); }
      });
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
  }

  var quoteDesc = document.getElementById('q-desc');
  if (quoteDesc && !quoteDesc.value.trim()) {
    var qsp = new URLSearchParams(window.location.search);
    var prod = qsp.get('produto');
    if (prod) {
      var sku = qsp.get('sku');
      var link = qsp.get('link');
      var isEN = ceIsEnglish || window.location.pathname.indexOf('orcamento-estrangeiro') !== -1;
      var msg;
      if (isEN) {
        msg = "I'm interested in this product: " + prod;
        if (sku) msg += ' (code ' + sku + ')';
        if (link) msg += '\nLink: ' + link;
      } else {
        msg = 'Tenho interesse neste produto: ' + prod;
        if (sku) msg += ' (código ' + sku + ')';
        if (link) msg += '\nLink: ' + link;
      }
      quoteDesc.value = msg;
    }
  }

  // AJAX "Carregue mais": o handler do tema base não estava interceptando o
  // clique, então o link fazia reload e jogava a página pro topo. Tratamos aqui.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-load-more]');
    if (!btn) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var url = btn.getAttribute('href');
    if (!url || btn.getAttribute('data-ce-busy') === '1') return;
    btn.setAttribute('data-ce-busy', '1');
    btn.classList.add('is-loading');
    var spin = btn.querySelector('.t4s-loading__spinner');
    if (spin) spin.classList.remove('t4s-dn');

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-ntajax-container] .t4s-products');
        var grid = document.querySelector('[data-ntajax-container] .t4s-products');
        if (!newGrid || !grid) { window.location.href = url; return; }

        Array.prototype.slice.call(newGrid.children).forEach(function (child) {
          grid.appendChild(document.importNode(child, true));
        });

        var wrap = btn.closest('[data-wrap-lm]');
        var newWrap = doc.querySelector('[data-wrap-lm]');
        if (wrap) {
          if (newWrap) { wrap.parentNode.replaceChild(document.importNode(newWrap, true), wrap); }
          else { wrap.remove(); }
        } else {
          btn.setAttribute('data-ce-busy', '0');
          btn.classList.remove('is-loading');
          if (spin) spin.classList.add('t4s-dn');
        }
        try { window.history.replaceState({}, '', url); } catch (e) {}
      })
      .catch(function () { window.location.href = url; });
  }, true);
})();

/* PDP mobile sticky "Comprar": delegate to the main AJAX add-to-cart button so
   the theme refreshes and opens its native cart drawer. The regular form submit
   remains as the progressive fallback when the AJAX hook is unavailable. */
(function () {
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ce-sticky-atc]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var form = document.getElementById(btn.getAttribute('data-ce-sticky-atc'));
    var cartUrl = btn.getAttribute('data-ce-cart-url') || '/cart';
    if (!form) { window.location.href = cartUrl; return; }
    var submit = form.querySelector('[data-atc-form]');
    if (submit) { submit.click(); return; }
    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    } catch (e) {
      window.location.href = cartUrl;
    }
  });
})();

/* Cart mobile sticky bar: trigger the native Shopify checkout button and keep
   the sticky total in sync with the live total. */
(function () {
  /* O CartPanda esconde o botão nativo (name="checkout") e injeta um clone visível
     (.cartx_elem_mainBtn) que faz o handoff para o checkout dele. Selecionar por
     classe/nome pegava o nativo ESCONDIDO — clicá-lo levava o cliente ao checkout da
     Shopify (com PayPal), ignorando o CartPanda. Por isso escolhemos sempre o
     primeiro botão de checkout de fato VISÍVEL, que é o do CartPanda quando ele
     está ativo, e o nativo quando a loja volta a usar o checkout da Shopify. */
  // CARTPANDA LEGACY - seletor anterior preservado para reversao:
  // function visibleCheckoutButton() {
  //   var candidates = document.querySelectorAll(
  //     '.cartx_elem_mainBtn, .t4s-btn__checkout, [name="checkout"]'
  //   );
  //   for (var i = 0; i < candidates.length; i++) {
  //     if (candidates[i].offsetParent !== null) return candidates[i];
  //   }
  //   return null;
  // }
  // Rollback CartPanda: restaure a funcao acima e volte a usa-la no clique abaixo.

  function nativeCheckoutButton() {
    return document.querySelector('.t4s-main-cart [name="checkout"]:not([disabled])') ||
      document.querySelector('form[data-cart-wrapper] [name="checkout"]:not([disabled])') ||
      document.querySelector('.t4s-btn__checkout[name="checkout"]:not([disabled])');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ce-cart-checkout]');
    if (!trigger) return;
    event.preventDefault();
    var real = nativeCheckoutButton();
    if (real) {
      real.click();
    } else {
      // Sem um botão nativo disponível, permaneça no carrinho.
      window.location.href = '/cart';
    }
  });

  function initCartTotalSync() {
    var dest = document.querySelector('[data-ce-cart-sticky-total]');
    var src = document.querySelector('.t4s-cart__totalPrice');
    if (!dest || !src) return;
    function sync() { dest.textContent = src.textContent.trim(); }
    sync();
    new MutationObserver(sync).observe(src, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartTotalSync);
  } else {
    initCartTotalSync();
  }
})();

/* WhatsApp click tracking is owned by ce-lead-tracking.js (v2). */
